export function isPastedFromExcel(html) {
  const excelRegex = /<meta.*?Microsoft Excel\s[\d].*?>/;
  return excelRegex.test(html);
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/text_editor/paste/excel/deserialize_excel.js